module.exports = __webpack_public_path__ + "static/media/Workshop_Arqui._Integracao.3ec402ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Workshop_Arqui._Integracao.png
// module id = 236
// module chunks = 0